var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictogram-wrapper"},[_c('img',{staticClass:"pictogramImage",attrs:{"src":_vm.imagePath}}),(_vm.showText)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.pictogram.text)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }